// extracted by mini-css-extract-plugin
export default {"bg":"App_bg__tiUL+"};